/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import supportChat from '../lib/index';
import '../localStorage';

const style = { right: 20, bottom: '15px' };

const isChatOpened = () => {
  const openState = localStorage.getItem('chat-app-state') === 'opened';
  return openState && (localStorage.getItem('chat-app-chat-opened-window') !== '0');
};

const NewChatSection = ({ user, showTooltip }) => {
  const [chatTooltip, setTooltip] = useState(false);

  useEffect(() => {
    supportChat.init({ user });
  }, [user]);

  useEffect(() => {
    if (showTooltip && !isChatOpened()) {
      setTooltip(true);
    }
  }, [showTooltip]);

  const closeChatTooltip = (e) => {
    if (e) e.stopPropagation();
    setTooltip(false);
  };

  const handleOpenChat = useCallback(() => {
    closeChatTooltip();
    if (supportChat && supportChat.startLoad) {
      supportChat.startLoad();
    }
  }, []);

  return (
    <div id="chat-wrapper-app">
      <div
        className="sv-chat-wrapper"
        style={style}
      >
        <svg width="0" height="0" style={{ position: 'absolute' }}>
          <symbol id="colored--32--chat-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path
              fill="#FFF"
              fillRule="evenodd"
              d="M21.25 4A2.75 2.75 0 0124 6.75V10h3.25A2.75 2.75 0 0130 12.75v12.5A2.75 2.75 0 0127.25 28h-16.5A2.75 2.75 0 018 25.25v-3.08l-4.49 2.69A1 1 0 012 24V6.75A2.75 2.75 0 014.75 4h16.5zM24 19.25A2.75 2.75 0 0121.25 22H10v3.25c0 .41.34.75.75.75h16.5a.75.75 0 00.75-.75v-12.5a.75.75 0 00-.75-.75H24v7.25zM21.25 6H4.75a.75.75 0 00-.75.75v15.48l3.49-2.09A1 1 0 018 20h13.25a.75.75 0 00.75-.75V6.75a.75.75 0 00-.75-.75zM16 14a1 1 0 010 2H8a1 1 0 010-2h8zm2-4a1 1 0 010 2H8a1 1 0 010-2h10z"
            />
          </symbol>
        </svg>
        <div className="sv-control-chat">
          <div className="sv-control-chat__body">
            <button className="sv-control-chat__action" onClick={handleOpenChat}>
              <div className="sv-control-chat__icon">
                <span className="sv-icon sv-icon--size--24" aria-hidden="true">
                  <svg className="sv-icon__pic" style={{ fill: 'currentColor' }}>
                    <use xlinkHref="#24--chat" />
                  </svg>
                </span>
              </div>
            </button>
            {chatTooltip && (
              <div className="sv-control-chat__popup" onClick={handleOpenChat}>
                <div className="sv-control-chat__popup-arrow" />
                <div className="sv-control-chat__popup-body">
                  <div className="sv-control-chat__popup-title">
                    We're always here to help 🙂
                  </div>
                  <button className="sv-control-chat__popup-control" onClick={closeChatTooltip}>
                    <span className="sv-icon sv-icon--size--16" aria-hidden="true">
                      <svg className="sv-icon__pic" style={{ fill: 'currentColor' }}>
                        <use xlinkHref="#16--close-small" />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

NewChatSection.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  showTooltip: PropTypes.bool,
};

NewChatSection.defaultProps = {
  showTooltip: true,
};

export default NewChatSection;
